import { useQuery } from '@tanstack/react-query';
import { getPublishChannels } from '@/api/publishChannels';

export const publishChannelKeys = {
  all: ['publish-channels'] as const,
  resolution: () => [...publishChannelKeys.all, 'resolution'] as const,
};

/**
 * The seller's publish destinations. Used by the publish step to decide
 * between "no choice", "choose" and "cloud handover", and by the design
 * overview to know which columns exist. The server derives the mode from the
 * account's platform, so the query takes no URL-derived input.
 */
export function usePublishChannels() {
  return useQuery({
    queryKey: publishChannelKeys.resolution(),
    queryFn: () => getPublishChannels(),
  });
}
